const CONFIG = {
    COMMENT_OFFSET: 3
}

export default CONFIG;